import { dateDiffInDays, formatDate } from "../../../utils/date";
import constants from "../../../utils/constants";
import { executeEvent } from "../../../utils/misc";
import {
  pushImpressionViewEvent,
  pushProductDetailEvent,
} from "../../../helpers/EnhancedEcommerce";

const handleImpressionViewEvent = (propertyTicker, accommodations) => {
  if (propertyTicker && accommodations && accommodations.get(propertyTicker)) {
    pushImpressionViewEvent(accommodations.get(propertyTicker).toJS());
  }
};

export function initGlobals(props) {
  window.wbkIsPropertyAvailable = props.isPropertyAvailable;
  window.wbkPropertyName = props.propertyName;
  window.wbkStartDate = formatDate(props.startDate, "DD-MM-YYYY");
  window.wbkEndDate = formatDate(props.endDate, "DD-MM-YYYY");
  window.wbkNights = dateDiffInDays(props.startDate, props.endDate);

  window.wbkSeniors =
    props.bookingFormFields &&
    props.bookingFormFields.fields &&
    props.bookingFormFields.fields[constants.OCCUPANTS_TYPE.SENIOR] &&
    !isNaN(props.bookingFormInitialValues[constants.OCCUPANTS_TYPE.SENIOR]) &&
    props.bookingFormInitialValues[constants.OCCUPANTS_TYPE.SENIOR];
  window.wbkAdults =
    props.bookingFormFields &&
    props.bookingFormFields.fields &&
    props.bookingFormFields.fields[constants.OCCUPANTS_TYPE.ADULT] &&
    !isNaN(props.bookingFormInitialValues[constants.OCCUPANTS_TYPE.ADULT]) &&
    props.bookingFormInitialValues[constants.OCCUPANTS_TYPE.ADULT];

  window.wbkTeenagers =
    props.bookingFormFields &&
    props.bookingFormFields.fields &&
    props.bookingFormFields.fields[constants.OCCUPANTS_TYPE.TEENAGER] &&
    !isNaN(props.bookingFormInitialValues[constants.OCCUPANTS_TYPE.TEENAGER]) &&
    props.bookingFormInitialValues[constants.OCCUPANTS_TYPE.TEENAGER];

  window.wbkChildren =
    props.bookingFormFields &&
    props.bookingFormFields.fields &&
    props.bookingFormFields.fields[constants.OCCUPANTS_TYPE.CHILDREN] &&
    !isNaN(props.bookingFormInitialValues[constants.OCCUPANTS_TYPE.CHILDREN]) &&
    props.bookingFormInitialValues[constants.OCCUPANTS_TYPE.CHILDREN];

  window.wbkBabies =
    props.bookingFormFields &&
    props.bookingFormFields.fields &&
    props.bookingFormFields.fields[constants.OCCUPANTS_TYPE.BABY] &&
    !isNaN(props.bookingFormInitialValues[constants.OCCUPANTS_TYPE.BABY]) &&
    props.bookingFormInitialValues[constants.OCCUPANTS_TYPE.BABY];

  let expandedBookables = props.expandedBookables;
  expandedBookables = (expandedBookables && expandedBookables.split(",")) || [];

  if (expandedBookables.length < 2) {
    if (props.isPropertyChain) {
      if (
        props.ARI.get(props.expandedBookables) &&
        props.ARI.get(props.expandedBookables).get("type") === constants.PROPERTY_TYPE.HOTEL
      ) {
        executeEvent(constants.EVENTS.START_STEP_ONE);
        handleImpressionViewEvent(props.propertyTicker, props.accommodations);
      } else {
        executeEvent(constants.EVENTS.START_STEP_ZERO);
      }
    } else {
      executeEvent(constants.EVENTS.START_STEP_ONE);
      handleImpressionViewEvent(props.propertyTicker, props.accommodations);
    }
  } else {
    executeEvent(constants.EVENTS.START_STEP_TWO);
    const accommodationTicker = props.expandedBookables && props.expandedBookables.split(",")[1];
    const activeAccommodation = props.accommodations
      .get(props.propertyTicker)
      .find(accommodation => accommodation.ticker === accommodationTicker);
    pushProductDetailEvent(props.propertyTicker, [activeAccommodation]);
  }

  executeEvent(constants.EVENTS.NO_AVAILABILITY);

  if (window.ga) {
    window.ga("send", "event", "No disponible", "consulta", "No disponibilidad", 0);
  }
}

export function dataUpdatedEvent(activeChildrenMap, configuration) {
  try {
    activeChildrenMap.map((child, index) => {
      if (child.inventory) {
        const event = new CustomEvent("dataUpdated", {
          detail: {
            ticker: index,
            configuration: configuration,
          },
        });
        document.dispatchEvent(event);
      }
    });
  } catch (error) {
    console.log("error creating event");
    console.log(error);
  }
}

export function updateGlobalsOnARIRequest(props) {
  window.wbkIsPropertyAvailable = props.isPropertyAvailable;
  window.configuration = props.externalConfiguration;

  executeEvent(constants.EVENTS.CHECKED_AVAILABILITY);

  if (props.isPropertyChain) {
    executeEvent(constants.EVENTS.CHANGED_BOOKING_FORM_CHAIN);
  } else {
    executeEvent(constants.EVENTS.CHANGED_BOOKING_FORM);
  }

  executeEvent(constants.EVENTS.NO_AVAILABILITY);

  if (window.ga) {
    window.ga("send", "event", "No disponible", "consulta", "No disponibilidad", 0);
  }

  dataUpdatedEvent(props.activeChildrenMap, props.externalConfiguration);
}
